import React, { PropTypes } from 'react';
import moment from 'moment-timezone';
import Avatar from 'common/components/avatar';

const ProfileMeta = ({
  avatar, country, user_timezone, username, first_name,
  last_name, last_login, date_joined, country_full_name
}) => {
  const time = user_timezone ? moment().tz(user_timezone).format('h:mm a') : null;

  return (<div className="profile-meta">
    <Avatar user={{ avatar, first_name, last_name, username }} extraClasses="avatar-xl avatar-shadow"/>
    <h4 className="hide-for-medium">{ username }</h4>
    <div className="location">
      { country && <span className="country">{ country_full_name }</span> }
    </div>
    { time && <div className="time">{time} local</div> }
    {date_joined && <div className="time">
      Member since {moment(date_joined).format('MMM, YYYY')}
    </div>}
    {last_login && <div className="time">Last seen {moment(last_login).fromNow()}</div>}
  </div>)
};

ProfileMeta.propTypes = {
  avatar: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  country: PropTypes.string,
  country_full_name: PropTypes.string,
  user_timezone: PropTypes.string,
};


export default ProfileMeta;



// WEBPACK FOOTER //
// ./profile/components/profile_meta.jsx